import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import style from "./Sales.module.scss";
import { getPieChartData } from "../../../../../api";
import useMerchantStore from "../../../../stores/merchant";

const PaymentDonutChart = () => {
  const activeApp = useMerchantStore((state) => state.activeApp);
  const [labels, setLabels] = useState([]);
  const [series, setSeries] = useState([]);

  useEffect(() => {
    getPieChartData({
      powerapp_id: activeApp.id,
      year: 2024,
    }).then((response) => {
      if (response.status) {
        setLabels(response.label);
        setSeries(response.data);
      }
    });
  }, []);

  const chartOptions = {
    chart: {
      type: "donut",
      width: "100px",
    },
    labels: labels,
    colors: ["#4A90E2", "#9B51E0", "#74C0FC", "#5DA39F", "#9BDF8F", "#F5A623"],
    legend: {
      position: "right",
      fontSize: "12px",
      fontFamily: "Work Sans",
      fontWeight: 400,
      labels: {
        colors: "#666",
        useSeriesColors: true,
      },
    },
    stroke: {
      width: 3,
      colors: ["#fff"],
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  return (
    <div className={style.donut_chart}>
      <Chart options={chartOptions} series={series} type="donut" height={350} />
    </div>
  );
};

export default PaymentDonutChart;
